import React from 'react';

const FileTypeIcon = ({ filename, size = "w-8 h-8" }) => {
  const getFileExtension = (filename) => {
    console.log('🔍 Debug - filename received:', filename);
    if (!filename) {
      console.log('❌ No filename provided');
      return '';
    }
    
    const parts = filename.split('.');
    console.log('🔍 Debug - filename parts:', parts);
    
    if (parts.length < 2) {
      console.log('❌ No extension found in filename');
      return '';
    }
    
    const extension = parts.pop().toLowerCase();
    console.log('🔍 Debug - extracted extension:', extension);
    return extension;
  };

  const getFileIconPath = (extension) => {
    console.log('🔍 Debug - looking up icon for extension:', extension);
    
    const iconMap = {
      // Document files
      'pdf': 'pdf.png',
      'doc': 'word.png',
      'docx': 'word.png',
      'txt': 'txt.png',
      'rtf': 'word.png',
      
      // Spreadsheet files
      'xls': 'excel.png',
      'xlsx': 'excel.png',
      'csv': 'excel.png',
      
      // Presentation files
      'ppt': 'powerpoint.png',
      'pptx': 'powerpoint.png',
      
      // Image files
      'jpg': 'image.png',
      'jpeg': 'image.png',
      'png': 'image.png',
      'gif': 'image.png',
      'svg': 'image.png',
      'bmp': 'image.png',
      'webp': 'image.png',
      
      // Video files
      'mp4': 'video.png',
      'avi': 'video.png',
      'mov': 'video.png',
      'wmv': 'video.png',
      'webm': 'video.png',
      'mkv': 'video.png',
      
      // Audio files
      'mp3': 'audio.png',
      'wav': 'audio.png',
      'flac': 'audio.png',
      'aac': 'audio.png',
      'ogg': 'audio.png',
      
      // Archive files
      'zip': 'zip.png',
      'rar': 'zip.png',
      '7z': 'zip.png',
      'tar': 'zip.png',
      'gz': 'zip.png',
      
      // Other files
      'json': 'code.png',
      'xml': 'code.png',
      'html': 'code.png',
      'css': 'code.png',
      'js': 'code.png',
    };

    const iconPath = iconMap[extension] || 'file.png';
    console.log('🔍 Debug - selected icon path:', iconPath);
    return iconPath;
  };

  const getFileTypeName = (extension) => {
    const nameMap = {
      'pdf': 'PDF Document',
      'doc': 'Word Document',
      'docx': 'Word Document',
      'txt': 'Text File',
      'xls': 'Excel Spreadsheet',
      'xlsx': 'Excel Spreadsheet',
      'csv': 'CSV File',
      'ppt': 'PowerPoint Presentation',
      'pptx': 'PowerPoint Presentation',
      'jpg': 'JPEG Image',
      'jpeg': 'JPEG Image',
      'png': 'PNG Image',
      'gif': 'GIF Image',
      'mp4': 'MP4 Video',
      'avi': 'AVI Video',
      'mov': 'QuickTime Video',
      'mp3': 'MP3 Audio',
      'wav': 'WAV Audio',
      'zip': 'ZIP Archive',
      'rar': 'RAR Archive',
    };
    
    return nameMap[extension] || 'File';
  };

  const extension = getFileExtension(filename);
  const iconPath = getFileIconPath(extension);
  const fileTypeName = getFileTypeName(extension);

  console.log('🔍 Debug - final values:', { filename, extension, iconPath, fileTypeName });

  return (
    <div className="flex items-center justify-center">
      <img
        src={`/icons/${iconPath}`}
        alt={`${fileTypeName} icon`}
        className={`${size} object-contain`}
        onError={(e) => {
          console.log('❌ Image load error for:', `/icons/${iconPath}`);
          e.target.src = '/icons/file.png';
        }}
        title={fileTypeName}
        onLoad={() => {
          console.log('✅ Image loaded successfully:', `/icons/${iconPath}`);
        }}
      />
    </div>
  );
};

export default FileTypeIcon;